"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var throttle_1 = __importDefault(require("lodash/throttle"));
// Memoization eliminates unnecessary re-renders (important: props must also be primitive or memoized)
var Ruler = react_1.default.memo(function (props) {
    var onResize = props.onResize, _a = props.throttle, throttle = _a === void 0 ? 100 : _a;
    var rulerElt = react_1.useRef(null);
    /*keep this style inline as when video is muted after miniPlayer is opened,
    this style will not be copied over to MiniPlayer window for Desktop.*/
    var style = {
        backgroundColor: 'transparent',
        border: 'none',
        height: '100%',
        position: 'absolute',
        width: '100%'
    };
    react_1.useEffect(function () {
        var updateSize = throttle_1.default(function () {
            var rulerWindow = rulerElt.current.contentWindow;
            var size = {
                height: rulerWindow.innerHeight,
                width: rulerWindow.innerWidth
            };
            onResize(size);
        }, throttle, { leading: true, trailing: true });
        rulerElt.current.contentWindow.addEventListener('resize', updateSize);
        updateSize();
        return function () {
            updateSize.cancel();
            rulerElt.current.contentWindow.removeEventListener('resize', updateSize);
        };
    }, []);
    return (react_1.default.createElement("iframe", { style: style, ref: rulerElt }));
});
exports.default = Ruler;
